'use client';

import { useCallback } from 'react';
import { useGetWorkspacesBasicLazyQuery } from '@frameio/graphql-client/generated';
import { useGetUnopenedNotificationGroupsCountLazyQuery } from '@frameio/notifications/gql';
import { DEFAULT_WORKSPACES_INITIAL_PAGE_COUNT } from '@frameio/shared/constants';
import { useGetAccountForPrimaryNavPanelLazyQuery } from '../../gql/queries/generated/GetAccountForPrimaryNavPanel';

export const usePreloadAccount = (): ((accountId: string) => void) => {
  const [loadAccount] = useGetAccountForPrimaryNavPanelLazyQuery();
  const [loadWorkspacesBasic] = useGetWorkspacesBasicLazyQuery();
  const [loadNotificationsCount] =
    useGetUnopenedNotificationGroupsCountLazyQuery();

  const preloadAccount = useCallback(
    (accountId: string) => {
      loadAccount({ variables: { accountId } });
      loadWorkspacesBasic({
        variables: {
          accountId,
          page: { first: DEFAULT_WORKSPACES_INITIAL_PAGE_COUNT },
        },
      });
      loadNotificationsCount({ variables: { accountId } });
    },
    [loadAccount, loadWorkspacesBasic, loadNotificationsCount]
  );

  return preloadAccount;
};
